<script setup>
const { icon, title } = defineProps({
    icon: {
        required: false,
        type: Object,
    },
    title: {
        required: false,
        type: String,
    },
});
</script>

<template>
    <div class="rounded-sm border border-gray-200 bg-white">
        <div
            v-if="title"
            class="flex w-full items-center gap-2 border-b border-gray-200 bg-indigo-100 px-4 py-3 text-xl font-bold text-indigo-600"
        >
            <component v-if="icon" :is="icon" class="size-5 shrink-0" />

            {{ title }}
        </div>

        <div class="px-4 py-3">
            <slot />
        </div>
    </div>
</template>
